import DeleteSvg from 'assets/icons/chat-bot/DeleteSvg';
import ChatSvg from 'assets/icons/chat-bot/Chat';
import AttachmentSvg from 'assets/icons/chat-bot/AttachmentSvg';
import RecordSvg from 'assets/icons/chat-bot/RecordSvg';
import ChatBotSvg from 'assets/icons/chat-bot/ChatBotSvg';
import DashboardSvg from 'assets/icons/sidebar-icons/DashboardSvg';
import SettingsSvg from 'assets/icons/sidebar-icons/SettingsSvg';
import ArrowSvg from 'assets/icons/sidebar-icons/ArrrowSvg';
import DeleteTableSVG from 'assets/icons/table-icons/DeleteSVG';
import CodeSVG from 'assets/icons/table-icons/CodeSVG';
import CalenderSVG from 'assets/icons/table-icons/CalenderSVG';
import LoginSVG from 'assets/icons/table-icons/LoginSVG';
import EditTableSVG from 'assets/icons/table-icons/EditTableSVG';
import EditSVG from 'assets/icons/table-icons/EditSVG';
import BackSVG from 'assets/icons/header/BackSVG';
import DownArrowSVG from 'assets/icons/table-icons/DownArrowSVG';
import FileSvg from 'assets/icons/chat-bot/FileSvg';
import SelectSVG from 'assets/icons/table-icons/SelectSVG';
import CameraSVG from 'assets/icons/table-icons/CameraSVG';
import UserSvg from 'assets/icons/sidebar-icons/UserSvg';
import BotsSvg from 'assets/icons/sidebar-icons/BotsSvg';
import KnowledgeBase from 'assets/icons/sidebar-icons/KnowledgeBase';
import ChatConsole from 'assets/icons/sidebar-icons/ChatConsole';
import MoreSvg from 'assets/icons/sidebar-icons/MoreSvg';
import BurgerMenu from 'assets/icons/sidebar-icons/BurgerMenu';
import FolderSVG from 'assets/icons/table-icons/FolderSVG';
import TableFile from 'assets/icons/chat-bot/TableFile';
import FlowSvg from 'assets/icons/bot-sidebar/FlowSVG';
import ChatBarSVG from 'assets/icons/bot-sidebar/ChatBarSVG';
import SearchSVG from 'assets/icons/chat-bot/SearchSvg';
import AISVG from 'assets/icons/chat-bot/AISVG';
import TalkSVG from 'assets/icons/workflow/TalkSVG';
import MessagesSVG from 'assets/icons/workflow/MessagesSVG';
import ImageSVG from 'assets/icons/workflow/ImageSVG';
import VideoSVG from 'assets/icons/workflow/VideoSVG';
import DocumentSVG from 'assets/icons/workflow/DocumentSVG';
import FormSVG from 'assets/icons/workflow/FormSVG';
import CarouselSVG from 'assets/icons/workflow/CarouselSVG';
import FlagSVG from 'assets/icons/workflow/Flag';
import CaptureSVG from 'assets/icons/workflow/CaptureSVG';
import QuestionSVG from 'assets/icons/workflow/QuestionSVG';
import ConditionSVG from 'assets/icons/workflow/ConditionSVG';
import LogicSvg from 'assets/icons/workflow/LogicSvg';
import ListenSvg from 'assets/icons/workflow/ListenSvg';
import NodeFolderSVG from 'assets/icons/workflow/nodeIcons/FolderSVG';
import NodeAISVG from 'assets/icons/workflow/nodeIcons/AiSVG';
import NodeFileSVG from 'assets/icons/workflow/nodeIcons/NodeFileSVG';
import IFSVG from 'assets/icons/workflow/nodeIcons/IFSVG';
import EndSVG from 'assets/icons/workflow/EndSVG';
import NodeFormSVG from 'assets/icons/workflow/nodeIcons/NodeFormSVG';
import SaveSVG from 'component/atom/forms/button/factory/assets/SaveSVG';
import MessageSVG from 'assets/icons/workflow/nodeIcons/MessageSVG';
import ExpandSVG from 'assets/icons/chat-bot/ExpandSVG';
import BurgerSVG from 'assets/icons/chat-bot/burgerSVG';
import SearchBarSVG from 'assets/icons/chat-bot/SearchBarSVG';
import ChatConsoleChatSVG from 'assets/icons/chat-bot/ChatConsoleChatSVG_';
import MoreButtonSVG from 'assets/icons/table-icons/MoreButtonSVG';
import ExitModalSVG from 'assets/icons/table-icons/ExitModalSVG';
import UploadFileSVG from 'assets/icons/table-icons/UploadFileSVG';
import SearchInputSVG from 'assets/icons/table-icons/SearchSVG';
import EyeSVG from 'assets/icons/inputs/EyeSVG';
import LockTableSVG from 'assets/icons/table-icons/LockTableSVG';
import CustomSVG from 'assets/icons/bot-sidebar/Custom';
import AiChatSVG from 'assets/icons/chat-bot/AiChatSVG';
import LockSVG from 'assets/icons/table-icons/LockSVG';
import SpeakerSVG from 'assets/icons/ChatConsole/Speaker';
import CopySVG from 'assets/icons/ChatConsole/Copy';
import RefreshSVG from 'assets/icons/ChatConsole/Refressh';
import LikeSVG from 'assets/icons/ChatConsole/Like';
import Dislike from 'assets/icons/ChatConsole/Dislike';
import REdirectSVG from 'assets/icons/workflow/RedirectSVG';
import PlusSVGs from 'assets/icons/workflow/PlusSVG';
import Url_Svg from 'assets/icons/table-icons/UrlSvg';
import ConversationSvg from 'assets/icons/ChatConsole/ConversationSvg';
import MessageSvg from 'assets/icons/ChatConsole/MessageSvg';
import DownloadSVG from 'assets/icons/chat-bot/DownloadSVG';
import CalendarFilterSVG from 'assets/icons/table-icons/CalendarFilterSVG';
import ArrowDownSVG from 'assets/icons/table-icons/ArrowDownSVG';
import DownloadFileSVG from 'assets/icons/table-icons/DownloadFileSVG';
import PlusFilledSVG from 'assets/icons/bot-sidebar/PlusSVG';
import Number from 'assets/icons/bot-sidebar/form/Number';
import PhoneNumber from 'assets/icons/bot-sidebar/form/PhoneNumber';
import Checkbox from 'assets/icons/bot-sidebar/form/Checkbox';
import Date from 'assets/icons/bot-sidebar/form/Date';
import RadioButton from 'assets/icons/bot-sidebar/form/RadioButton';
import Text from 'assets/icons/bot-sidebar/form/Text';
import Dropdown from 'assets/icons/bot-sidebar/form/Dropdown';
import RestrictAccess from 'assets/icons/table-icons/REstrictAccess';
import CloseSVG from 'assets/icons/table-icons/CloseSVG';
import WebsiteLink from 'assets/icons/table-icons/WebsiteLink';
import ThumbsUpSVG from 'assets/icons/ChatConsole/ThumbUp';
import EmailSVG from 'assets/icons/bot-sidebar/form/EmailSVG';
import PrioritySVG from 'assets/icons/bot-sidebar/form/PriotitySVG';
import QuickTourSvg from 'assets/icons/sidebar-icons/QuickTourSvg';
import ContactSupportSvg from 'assets/icons/sidebar-icons/ContactSupportSvg';
import StarSVG from 'assets/icons/docs/StarSVG';
import RocketSVG from 'assets/icons/docs/RocketSVG';
import KnowledgeBaseSVG from 'assets/icons/docs/KnowledgeBaseSVG';
import Sync from 'assets/icons/agent/Sync';
import Clock from 'assets/icons/agent/Clock';
import CheckShield from 'assets/icons/agent/CheckShield';
import DataAiSVG from 'assets/icons/workflow/nodeIcons/DataAiSVG';
import DefaultBotSVG from 'assets/icons/chat-bot/DefaultBotSVG';
import Delete2SVG from 'assets/icons/table-icons/Delete2SVG';
import FailedSVG from 'assets/icons/agent/FailedSVG';
import SuccessSVG from 'assets/icons/agent/SuccessSVG';
import InProgressSVG from 'assets/icons/agent/InProgressSVG';
import Calendar2SVG from 'assets/icons/table-icons/Calendar2SVG';
import Clock2SVG from 'assets/icons/table-icons/Clock2SVG';
import ChevronDownSVG from 'assets/icons/agent/ChevronDownSVG';
import BackSubSVG from 'assets/icons/header/BackSubSVG';
import MinimizeSVG from 'assets/icons/bot-sidebar/MinimizeSVG';
import MenuExpandSVG from 'assets/icons/bot-sidebar/MenuExpandSVG';
import ThemeSVG from 'assets/icons/bot-sidebar/ThemeSVG';
import TotalLeadsSVG from 'assets/icons/bot-sidebar/form/TotalLeadsSVG';
import HighIntentLeadsSVG from 'assets/icons/bot-sidebar/form/HighIntentLeadsSVG';
import ActiveConversationsSVG from 'assets/icons/bot-sidebar/form/ActiveConversationsSVG';
import FilesSubmittedSVG from 'assets/icons/bot-sidebar/form/FilesSubmittedSVG';
import FileCheckSVG from 'assets/icons/table-icons/FileCheckSVG';
import ConversationDots from 'assets/icons/ChatConsole/ConversationDots';
import AddSVG from 'assets/icons/categories/AddSVG';
import InfoSVG from 'assets/icons/dashboard/InfoSVG';
import Download2SVG from 'assets/icons/dashboard/Download2SVG';
import MaximizeSVG from 'assets/icons/dashboard/MaximizeSVG';
import MessagesConversationSVG from 'assets/icons/dashboard/MessagesSVG';
import EngagementSVG from 'assets/icons/dashboard/EngagementSVG';
import ConversationLengthSVG from 'assets/icons/dashboard/ConversationLengthSVG';
import LineChartSVG from 'assets/icons/dashboard/LineChartSVG';
import LineChart2SVG from 'assets/icons/dashboard/LineChart2SVG';
import TableGridSVG from 'assets/icons/agent/TableGridSVG';
import SortSVG from 'assets/icons/table-icons/SortSVG';
import Rocket2SVG from 'assets/icons/home/Rocket2SVG';
import SendVector from 'assets/icons/ChatConsole/SendVector';
import threeDots from 'component/atom/forms/button/factory/assets/more';
import DotsSVG from 'assets/icons/branding/DotsSVG';
import MaximizeBrandingSVG from 'assets/icons/branding/MaximizeBrandingSVG';
import MinimizeBrandingSVG from 'assets/icons/branding/MinimizeBrandingSVG';
import MicSVG from 'assets/icons/branding/MicSVG';
import SendSVG from 'assets/icons/branding/SendSVG';
import EyeBrandingSVG from 'assets/icons/branding/EyeBrandingSVG';
import UploadBrandingSVG from 'assets/icons/branding/UploadBrandingSVG';
import ColorPickerSVG from 'assets/icons/branding/ColorPickerSVG';
import WhiteThemeSVG from 'assets/icons/branding/WhiteThemeSVG';
import BlackThemeSVG from 'assets/icons/branding/BlackThemeSVG';
import GradientStyleSVG from 'assets/icons/branding/GradientStyleSVG';
import BasicStyleSVG from 'assets/icons/branding/BasicStyleSVG';
import ButtonGradientSVG from 'assets/icons/branding/ButtonGradientSVG';
import ButtonBasicSVG from 'assets/icons/branding/ButtonBasicSVG';
import EyeBrandingStrippedSVG from 'assets/icons/branding/EyeBrandingStippedSVG';

import draggable from '../../organism/chat-console/components/assets/DraggbleSvg';
import Code2SVG from 'assets/icons/workflow/Code2SVG';
import NoDataSVG from 'assets/icons/no-data/NoDataSVG';
import NoUserSVG from 'assets/icons/no-data/NoUserSVG';
import NoSystemSVG from 'assets/icons/no-data/NoSystemSVG';
import NoAgentSVG from 'assets/icons/no-data/NoAgentSVG';
import NoChatSVG from 'assets/icons/no-data/NoChatSVG';
import ResetSVG from 'assets/icons/inputs/ResetSVG';
import PreviewSvg from 'assets/icons/table-icons/PreviewSvg';
import AI2SVG from 'assets/icons/agent/AI2SVG';
import WhatsappSVG from 'assets/icons/workflow/WhatsappSVG';
import WhatsappColoredSVG from 'assets/icons/workflow/nodeIcons/WhatsappColoredSVG';
import TelegramSVG from 'assets/icons/workflow/nodeIcons/TelegramSVG';
import DevSVG from 'assets/icons/workflow/DevSVG';
import SystemSVG from 'assets/icons/workflow/SystemSVG';
import ApiSVG from 'assets/icons/workflow/ApiSVG';
import GetDataSVG from 'assets/icons/workflow/GetDataSVG';
import BellSvg from 'assets/icons/sidebar-icons/BellSvg';
import ExitSvg from 'assets/icons/sidebar-icons/ExitSvg';
import AddMember from 'assets/icons/table-icons/AddMemberSVG';
import Send2SVG from 'assets/icons/workflow/Send2SVG';
import FailedNotificationSVG from 'assets/icons/notifications/FailedNotificationSVG';
import UpdateNotificationSVG from 'assets/icons/notifications/UpdateNotificationSVG';
import WarningNotificationSVG from 'assets/icons/notifications/WarningNotificationSVG';
import AssociatedSVG from 'assets/icons/agent/AssociatedSVG';
const EmptySpan = () => {
  <></>;
};
const svgMap = {
  dashboard: DashboardSvg,
  settings: SettingsSvg,
  delete: DeleteSvg,
  chat: ChatSvg,
  attachment: AttachmentSvg,
  record: RecordSvg,
  arrow: ArrowSvg,
  chat_bot: ChatBotSvg,
  attachments: AttachmentSvg,
  edit_table: EditTableSVG,
  delete_table: DeleteTableSVG,
  code: CodeSVG,
  calender: CalenderSVG,
  logIn: LoginSVG,
  edit: EditSVG,
  back: BackSVG,
  down_arrow: DownArrowSVG,
  file: FileSvg,
  'icon-dashboard': DashboardSvg,
  'icon-settings': SettingsSvg,
  'icon-users': UserSvg,
  bots: BotsSvg,
  'icon-knowledgebase': KnowledgeBase,
  'icon-chat-console': ChatConsole,
  more: MoreSvg,
  'icon-chat-bot': BotsSvg,
  'burger-menu': BurgerMenu,
  select: SelectSVG,
  camera: CameraSVG,
  folder: FolderSVG,
  'table-file': TableFile,
  flow: FlowSvg,
  'chat-bart': ChatBarSVG,
  search: SearchSVG,
  ai: AISVG,
  talk: TalkSVG,
  messages: MessagesSVG,
  image: ImageSVG,
  video: VideoSVG,
  document: DocumentSVG,
  form: FormSVG,
  carousel: CarouselSVG,
  flag: FlagSVG,
  capture: CaptureSVG,
  question: QuestionSVG,
  condition: ConditionSVG,
  end: EndSVG,
  logic: LogicSvg,
  whatsapp: WhatsappSVG,
  'whatsapp-colored': WhatsappColoredSVG,
  telegram: TelegramSVG,
  dev: DevSVG,
  system: SystemSVG,
  api: ApiSVG,
  'get-data': GetDataSVG,
  listen: ListenSvg,
  'node-question': QuestionSVG,
  'node-folder': NodeFolderSVG,
  'node-ai': NodeAISVG,
  'node-file': NodeFileSVG,
  'node-if': IFSVG,
  'node-end': EndSVG,
  'node-form': NodeFormSVG,
  'node-capture': CaptureSVG,
  save: SaveSVG,
  'node-image': ImageSVG,
  'node-video': VideoSVG,
  'node-message': MessageSVG,
  'node-redirect': REdirectSVG,
  plusSVG: PlusSVGs,
  plusFilledSVG: PlusFilledSVG,
  url: Url_Svg,
  table_more_button: MoreButtonSVG,
  exit_modal: ExitModalSVG,
  upload_file: UploadFileSVG,
  search_input: SearchInputSVG,
  expand: ExpandSVG,
  burger: BurgerSVG,
  'search-bar': SearchBarSVG,
  'message-console': ChatConsoleChatSVG,
  'eye-icon': EyeSVG,
  'lock-table': LockTableSVG,
  custom: CustomSVG,
  'ai-chat': AiChatSVG,
  'data-ai': DataAiSVG,
  lock: LockSVG,
  speakerSvg: SpeakerSVG,
  copySvg: CopySVG,
  refetchSvg: RefreshSVG,
  likeSvg: LikeSVG,
  dislikeSvg: Dislike,
  conversation: ConversationSvg,
  message: MessageSvg,
  download: DownloadSVG,
  calendar: CalendarFilterSVG,
  arrow_down: ArrowDownSVG,
  'download-file-SVG': DownloadFileSVG,
  number: Number,
  phoneNumber: PhoneNumber,
  checkbox: Checkbox,
  date: Date,
  radioButton: RadioButton,
  text: Text,
  dropdown: Dropdown,
  emailFormSVG: EmailSVG,
  'restrict-access': RestrictAccess,
  closeSvg: CloseSVG,
  websiteLink: WebsiteLink,
  thumbsUp: ThumbsUpSVG,
  priority: PrioritySVG,
  'quick-tour': QuickTourSvg,
  'contact-support': ContactSupportSvg,
  star: StarSVG,
  rocket: RocketSVG,
  knowledge: KnowledgeBaseSVG,
  sync: Sync,
  clock: Clock,
  'check-shield': CheckShield,
  'default-bot': DefaultBotSVG,
  delete2: Delete2SVG,
  failed: FailedSVG,
  success: SuccessSVG,
  inProgress: InProgressSVG,
  calendar2: Calendar2SVG,
  clock2: Clock2SVG,
  chevronDown: ChevronDownSVG,
  backSub: BackSubSVG,
  minimizeSidebar: MinimizeSVG,
  menuExpand: MenuExpandSVG,
  theme: ThemeSVG,
  'total-leads': TotalLeadsSVG,
  'high-intent-leads': HighIntentLeadsSVG,
  'active-conversations': ActiveConversationsSVG,
  'files-submitted': FilesSubmittedSVG,
  fileCheck: FileCheckSVG,
  'conversation-dots': ConversationDots,
  add: AddSVG,
  info: InfoSVG,
  download2: Download2SVG,
  maximize: MaximizeSVG,
  messagesConversation: MessagesConversationSVG,
  engagement: EngagementSVG,
  conversationLength: ConversationLengthSVG,
  lineChart: LineChartSVG,
  lineChart2: LineChart2SVG,
  tableGrid: TableGridSVG,
  sort: SortSVG,
  rocket2: Rocket2SVG,
  dots: DotsSVG,
  maximizeBranding: MaximizeBrandingSVG,
  minimizeBranding: MinimizeBrandingSVG,
  mic: MicSVG,
  send: SendSVG,
  eyeBranding: EyeBrandingSVG,
  eyeBrandingStripped: EyeBrandingStrippedSVG,
  uploadBranding: UploadBrandingSVG,
  colorPicker: ColorPickerSVG,
  whiteTheme: WhiteThemeSVG,
  blackTheme: BlackThemeSVG,
  gradientStyle: GradientStyleSVG,
  basicStyle: BasicStyleSVG,
  buttonGradient: ButtonGradientSVG,
  buttonBasic: ButtonBasicSVG,
  // export: exportSvg,
  three_dots: threeDots,
  send_vector: SendVector,
  draggable: draggable,
  connect: Code2SVG,
  noData: NoDataSVG,
  noUser: NoUserSVG,
  noSystem: NoSystemSVG,
  noAgent: NoAgentSVG,
  noChat: NoChatSVG,
  reset: ResetSVG,
  eye: PreviewSvg,
  ai2: AI2SVG,
  bell: BellSvg,
  exit: ExitSvg,
  'add-member': AddMember,
  send2: Send2SVG,
  'failed-notification': FailedNotificationSVG,
  'update-notification': UpdateNotificationSVG,
  'warning-notification': WarningNotificationSVG,
  associated: AssociatedSVG,
};
export default svgMap;
export { svgMap, EmptySpan };
